import HomeIcon from "@material-ui/icons/Home";
import InfoIcon from "@material-ui/icons/Info";
import { IRoute } from "src/common/typings/routes";
import { AddInventoryItem } from "./pages/AddItem";
import { ListItems } from "./pages/ListItems";
import { ListStatus } from "./pages/ListStatus/ListStatus";
import { WereHouse } from "./WereHouse";
import { InventoryHistory } from "./pages/InventoryHistory";
import { BincardItems } from "./pages/Bincard";

export const WereHouseRoute: IRoute = {
  title: "Warehouse",
  path: "/ware-house",
  icon: HomeIcon,
  component: WereHouse,
  guard: true,
  subRoutes: [
    {
      icon: InfoIcon,
      component: AddInventoryItem,
      path: "/add-inventory",
      title: "Add Inventory Item",
    },
    {
      icon: InfoIcon,
      component: ListItems,
      path: "/list-inventory",
      title: "Inventory Items",
    },
    {
      icon: InfoIcon,
      component: ListStatus,
      path: "/status-inventory",
      title: "Inventory Status",
    },
    {
      icon: InfoIcon,
      component: InventoryHistory,
      path: "/inventory-history",
      title: "Inventory History",
    },
    {
      icon: InfoIcon,
      component: BincardItems,
      path: "/inventory-bincard",
      title: "Inventory Bincard",
    },
    // {
    //   icon: InfoIcon,
    //   component: ReceiveIssueItems,
    //   path: "/receive-issue",
    //   title: "Inventory Receive Issue Items",
    // },
  ],
};
